// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3ZqQK","row":"styles_row__w20hc"};